import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ValidationService } from '../../../../shared/services/validation.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApprovalService } from '../../../services';

import swal from 'sweetalert2';

@Component({
    templateUrl: './approval-rule.component.html'
})

export class BusinessRuleComponent implements OnInit {

    businessRuleForm: FormGroup;
    multiple:any;
    displayModalForm = false;
    activeIndex:any;
    businessRuleTableData: any[];
    businessRuleTableCols: any[];
    selectedId:number = null;
    panelHeader = 'New Business Rule';

    constructor(
        private fb: FormBuilder, 
        private loadingService: LoadingService,
        private validationService: ValidationService, 
        private approvalService: ApprovalService,
    ) { }
    
    ngOnInit() {
        this.loadingService.show();

        this.businessRuleTableCols = [
            { field: 'description', header: 'Description' },
            { field: 'minimumAmount', header: 'Minimum Amount' },
            { field: 'maximumAmount', header: 'Maximum Amount' },
            { field: 'pep', header: 'PEP' },
        ];

        this.loadAllForms(); 
        this.loadAllBusinessRules();

        this.loadingService.hide();
    }

    loadAllForms() {
        this.businessRuleForm = this.fb.group({
            description: ['', Validators.required],
            minimumAmount: [''],
            maximumAmount: [''],
            pepAmount: [''],
            pep: [false],
            projectRelated: [false],
            insiderRelated: [false],
            onLending: [false],
            interventionFunds: [false],
            orrBasedApproval: [false],
            withoutInstruction: [false],
            domiciliationNotInPlace: [false],
            tenor: [''],
        });
        let control = this.businessRuleForm.get('pepAmount');
        control.disable();
    }

    loadAllBusinessRules() {
        this.approvalService.getBusinessRules().subscribe((data: any) => {
            this.businessRuleTableData = data.result;
        });
    }

    showModalForm() {
        this.loadAllForms();
        this.panelHeader = 'New Business Rule';
        this.displayModalForm = true;
        this.selectedId = null;
    }

    editBusinessRule(row) {
        this.selectedId = row.levelBusinessRuleId;
        this.panelHeader = 'Edit Business Rule';
        this.displayModalForm = true;
        this.businessRuleForm = this.fb.group({
            description: row.description,
            minimumAmount: row.minimumAmount,
            maximumAmount: row.maximumAmount,
            pepAmount: row.pepAmount,
            pep: row.pep,
            projectRelated: row.projectRelated,
            insiderRelated: row.insiderRelated,
            onLending: row.onLending,
            interventionFunds: row.interventionFunds,
            orrBasedApproval: row.orrBasedApproval,
            withoutInstruction: row.withoutInstruction,
            domiciliationNotInPlace: row.domiciliationNotInPlace,
            tenor: row.tenor,
        });
    }

    submitGroupForm(form) {
        let bodyObj = {
            description: form.value.description,
            minimumAmount: form.value.minimumAmount,
            maximumAmount: form.value.maximumAmount,
            pepAmount: form.value.pepAmount,
            pep: form.value.pep,
            projectRelated: form.value.projectRelated,
            insiderRelated: form.value.insiderRelated,
            onLending: form.value.onLending,
            interventionFunds: form.value.interventionFunds,
            orrBasedApproval: form.value.orrBasedApproval,
            withoutInstruction: form.value.withoutInstruction,
            domiciliationNotInPlace: form.value.domiciliationNotInPlace,
            tenor: form.value.tenor,
        };

        this.loadingService.show();
        if (this.selectedId === null) {
            this.approvalService.addBusinessRule(bodyObj).subscribe((response: any) => {//
                if (response.success === true) {
                    swal('Fintrak Banking', response.message, 'success');
                } else {
                    swal('Fintrak Banking', response.message, 'error');
                }
                this.displayModalForm = false;
                this.loadAllBusinessRules();
                this.loadingService.hide();
                this.loadAllForms();
            }, (err) => {
                swal('Fintrak Banking', JSON.stringify(err), 'error');
            });
        } else {
            this.approvalService.updateBusinessRule(this.selectedId, bodyObj).subscribe((response: any) => {//
                if (response.success === true) {
                    swal('Fintrak Banking', response.message, 'success');
                } else {
                    swal('Fintrak Banking', response.message, 'error');
                }
                this.displayModalForm = false;
                this.loadAllBusinessRules();
                this.loadingService.hide();
                this.loadAllForms();
            }, (err) => {
                swal('Fintrak Banking', JSON.stringify(err), 'error');
            });
        }
    }

    isPoliticallyExposedPersonChange(checked) {
        let control = this.businessRuleForm.get('pepAmount');
        if (checked) control.enable();
        else control.disable();
        control.updateValueAndValidity();
    }
}